module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-3x2-9fc4ff7b9b4511ab2d005f190a672345.jpg";